// state.js

export default {
    menuTree: [],
    menuItems: []
};
